export const PlusIcon = ({ color = "#517FF5" }) => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 7.75C0.585786 7.75 0.25 8.08579 0.25 8.5C0.25 8.91421 0.585786 9.25 1 9.25V7.75ZM16 9.25C16.4142 9.25 16.75 8.91421 16.75 8.5C16.75 8.08579 16.4142 7.75 16 7.75V9.25ZM7.75 16C7.75 16.4142 8.08579 16.75 8.5 16.75C8.91421 16.75 9.25 16.4142 9.25 16H7.75ZM9.25 1C9.25 0.585786 8.91421 0.25 8.5 0.25C8.08579 0.25 7.75 0.585786 7.75 1H9.25ZM8.5 7.75H1V9.25H8.5V7.75ZM8.5 9.25H16V7.75H8.5V9.25ZM7.75 8.5V16H9.25V8.5H7.75ZM9.25 16V1H7.75V16H9.25Z"
      fill={color}
    />
  </svg>
);
